/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneOption/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaSelectOneOptionMulti from './TysiaSelectOneOptionMulti/index'
import TysiaSelectOneOptionMultiInput from './TysiaSelectOneOptionMulti/TysiaSelectOneOptionMultiInput/index'
import TysiaSelectOneOptionMultiText from './TysiaSelectOneOptionMulti/TysiaSelectOneOptionMultiText/index'
import TysiaSelectOneOptionSingle from './TysiaSelectOneOptionSingle/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneOption({
  children,
  viewPath = "/DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/TysiaSelectOneOption",
  isMultiChoice,
  size,
  onClick,
  isSelected,
  disabled,
  text = "Option",
  alignSelf
  
}) {
  return (<React.Fragment
>
<fromFlow.When is={!isMultiChoice}>
<TysiaSelectOneOptionSingle
  viewPath={`${viewPath}/TysiaSelectOneOptionSingle`}
 size={size}
 onClick={onClick}
 selected={isSelected}
 disabled={disabled}
 text={text}
/>
</fromFlow.When>
<fromFlow.When is={isMultiChoice}>
<TysiaSelectOneOptionMulti
  viewPath={`${viewPath}/TysiaSelectOneOptionMulti`}
 size={size}
 onChange={onClick}
 value={isSelected}
 alignSelf={alignSelf}
 disabled={disabled}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneOptionMultiInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptionMultiInput`}
/>
<TysiaSelectOneOptionMultiText
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptionMultiText`}
 text={text}
/>
</React.Fragment>
)}
</TysiaSelectOneOptionMulti>
</fromFlow.When>
{children}
</React.Fragment>)
}